import { render, staticRenderFns } from "./call.vue?vue&type=template&id=ab50592c&scoped=true&"
import script from "./call.vue?vue&type=script&lang=js&"
export * from "./call.vue?vue&type=script&lang=js&"
import style0 from "./call.vue?vue&type=style&index=0&id=ab50592c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab50592c",
  null
  
)

export default component.exports